import React from 'react'
import MainHeader from '../layout/MainHeader'
import AppointmentLandingPage from '../components/appointment-landing/AppointmentLandingPage'
import AppointmentLandingFooter from '../components/appointment-landing/AppointmentLandingFooter'
import CopyRight from '../layout/CopyRight'
import { useEffect } from 'react'
import MainResHeader from '../layout/MainResHeader'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const AppointmentPage = () => {

  useEffect(() => {
    window.scrollTo(0,0)
  },[])

  return (
    
    <div style={{ overflow:'hidden'}}>

<HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Book Appointment | United Lab Care</title>
      <meta name="description" content="Book your appointment at 43 Roosevelt Rd, Villa Park, IL (Near Roosevelt Rd and Ardmore Ave, Adjacent to Aldi)." />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Book Appointment | United Lab Care" />
	<meta property="og:description" content="Book your appointment at 43 Roosevelt Rd, Villa Park, IL (Near Roosevelt Rd and Ardmore Ave, Adjacent to Aldi)." />
	<meta property="og:url" content="https://unitedlabcare.com/book-appointment/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-08-11T19:55:08+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2022/01/United-Lab-Care-Logo.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="2 minutes" />
      </Helmet>
    </HelmetProvider>

        <MainResHeader/>

        <AppointmentLandingPage/>

        <AppointmentLandingFooter/>

        <CopyRight/>
    </div>
  )
}

export default AppointmentPage